import { default as dayjs } from 'dayjs';

export const formatDate = (date: string | Date) =>
  dayjs(date).format('MMMM D, YYYY h:mm A');
export const formatSecondaryDate = (date: string | Date) =>
  dayjs(date).format('DD/MM/YYYY');

export const formatNumber = (num: string | number) => {
  if (num === '' || num === undefined || num === null) return '';
  const number =
    typeof num === 'string' ? parseFloat(num.replace(/,/g, '')) : num;
  if (isNaN(number)) return '';
  return number.toLocaleString();
};
